const Advert = require('./advert');

class Advert_Article extends Advert {
  constructor() {
    super();
    this.data;
    this.ex;
    this.admData;
    this.GD_params;
    this.DOM;
  }

  renderOneImg() {
    this.DOM = $(`<a href="${this.ex.url}" class="news-item shanque-ad-item shanque-ad-item-expore advert-article" data-imgcount="1"  data-cm="${cm}" data-pm="${pm}"
                  ag-expose="ag_extend:info_ad"
                  ag-click="ag_extend:info_ad">
                    <div class="news-title stat-recsys-click">${this.ex.mainTitle}</div>
                    <div class="thumbnail-list stat-recsys-click">
                        <div class="thumbnail">
                        <img src="${this.ex.image1Url}" alt="">
                        </div>
                    </div>
                    <div class="publish-time">推广</div>
                </a>`);
  }

  renderMutiImg() {
    this.DOM = $(`<a href="${this.ex.url}" type="btn" class="stat-recsys-click news-item advert-article" data-imgcount="3"
                  ag-expose="ag_extend:info_ad"
                  ag-click="ag_extend:info_ad">
                        <div class="news-title stat-recsys-click">${this.ex.mainTitle}</div>
                        <div class="thumbnail-list stat-recsys-click">
                            <div class="thumbnail">
                            <img src="${this.ex.image1Url}" alt="">
                            </div>
                            <div class="thumbnail">
                            <img src="${this.ex.image2Url}"  alt="">
                            </div>
                            <div class="thumbnail">
                            <img src="${this.ex.image3Url}"  alt="">
                            </div>
                        </div>
                        <div class="publish-time">推广</div>
                    </a>`);
  }

  SetDOM() {
    if (this.ex.image2Url) {
      this.renderMutiImg();
    } else {
      this.renderOneImg();
    }
  }

}

module.exports = Advert_Article;


// WEBPACK FOOTER //
// ./lib/js/module/m_advert/module/advert_article.js